import { Component, OnInit, Input } from '@angular/core';
import { UserService } from '../../../dashboard/program-list/user.service';
import { SupportTicket } from '../../../models/support-ticket';

@Component({
  selector: 'app-impersonate',
  templateUrl: './impersonate.component.html',
  styleUrls: ['./impersonate.component.less']
})
export class ImpersonateComponent implements OnInit {
  @Input() user: any;
  public tickets: SupportTicket[];
  public ticket: SupportTicket = null;
  public otherReason: string = '';
  public requesting: boolean;
  public url: string;

  constructor(private userService: UserService) { }

  ngOnInit() {
    this.userService.getSupportTickets().subscribe(tickets => this.tickets = tickets);
  }

  request(event) {
    event.preventDefault();

    if (this.requesting) {
      return;
    }
    this.requesting = true;

    let reason;
    if (this.ticket) {
      reason = `Support ticket #${this.ticket.id}`;
    }
    else {
      let trimmed = this.otherReason.trim();
      if (trimmed) {
        reason = trimmed;
      }
      else {
        alert("Must provide a reason for impersonation");
        this.requesting = false;
        return;
      }
    }

    this.userService.impersonateUser(this.user.id, reason).subscribe(url => {
      this.url = url;
      this.requesting = false;
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/user-settings/impersonate/impersonate.component.ts